document.addEventListener('DOMContentLoaded', function () {
  const scellageBlock = document.querySelector('.scellage-option');
  const crossSellBlock = document.querySelector('essential-upsell-cross-sell-app-block');
  if (scellageBlock && crossSellBlock) {
    crossSellBlock.parentNode.insertBefore(scellageBlock, crossSellBlock);
  }
});

document.addEventListener('click', function (e) {
  const crossSellButton = e.target.closest('essential-upsell-cross-sell-app-block button');
  if (!crossSellButton) return;

  const checkbox = document.getElementById('ScellageOption');
  if (checkbox) {
    checkbox.checked = false;
  }
}, true);

function safeRenderContents(notif, parsedState) {
  notif.cartItemKey = parsedState.key;

  notif.getSectionsToRender().forEach(function (section) {
    if (!parsedState.sections || !parsedState.sections[section.id]) return;
    const sectionElement = document.getElementById(section.id);
    if (!sectionElement) return;

    const parsedHTML = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');

    if (section.id === 'cart-notification-product') {
      const mainProductBlock = parsedHTML.getElementById('cart-notification-product');
      if (mainProductBlock) {
        sectionElement.innerHTML = mainProductBlock.innerHTML;
      } else {
        // Repli : si l'ID fixe est introuvable, on prend le premier .cart-item du wrapper
        const wrapper = parsedHTML.getElementById('shopify-section-cart-notification-product');
        const firstItem = wrapper ? wrapper.querySelector('.cart-item') : null;
        if (firstItem) {
          sectionElement.innerHTML = firstItem.outerHTML;
        }
      }
      return;
    }

    const wrapper = parsedHTML.getElementById('shopify-section-' + section.id);
    if (!wrapper) return;
    sectionElement.innerHTML = wrapper.innerHTML;
  });
  notif.open();
}

document.addEventListener('submit', function (e) {
  const form = e.target;
  if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

  const checkbox = document.getElementById('ScellageOption');
  if (!checkbox || !checkbox.checked) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  const mainVariantId = form.querySelector('input[name="id"]').value;
  const addonVariantId = checkbox.dataset.variantId;
  const submitBtn = form.querySelector('button[type="submit"]');
  const notif = document.querySelector('cart-notification');
  const productInfo = document.querySelector('product-info');

  if (notif && productInfo) {
    notif.productId = productInfo.dataset.productId;
  }
  if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        { id: mainVariantId, quantity: 1 },
        { id: addonVariantId, quantity: 1, parent_id: mainVariantId }
      ],
      sections: notif ? notif.getSectionsToRender().map(s => s.id) : [],
      sections_url: window.location.pathname
    })
  })
  .then(res => res.json())
  .then(response => {
    if (notif) {
      safeRenderContents(notif, response);
    }
  })
  .catch(err => console.error('[Scellage] ERREUR:', err))
  .finally(() => {
    if (submitBtn) submitBtn.removeAttribute('disabled');
    checkbox.checked = false;
  });
}, true);